import { render, staticRenderFns } from "./recharge-item-new.vue?vue&type=template&id=37349259&scoped=true"
import script from "./recharge-item-new.vue?vue&type=script&lang=ts"
export * from "./recharge-item-new.vue?vue&type=script&lang=ts"
import style0 from "./recharge-item-new.vue?vue&type=style&index=0&id=37349259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37349259",
  null
  
)

export default component.exports